"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CrudBuilder = void 0;

var _common = require("./../common");

/* eslint-disable max-classes-per-file, @typescript-eslint/no-shadow */

/* eslint-enable @typescript-eslint/no-explicit-any */
const Create = Service => class Create extends Service {
  create(model, options) {
    return this.client.post('/', model, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

};

const Retrieve = Service => class Retrieve extends Service {
  retrieve(id, options) {
    return this.client.get(id, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

};

const Update = Service => class Update extends Service {
  update(id, model, options) {
    return this.client.put(id, model, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

};

const Patch = Service => class Patch extends Service {
  patch(id, model, options) {
    const config = (0, _common.createRequestConfig)(options);
    return this.client.patch(id, model, { ...config,
      headers: { ...((config === null || config === void 0 ? void 0 : config.headers) || {}),
        [_common.CONTENT_TYPE_HEADER]: _common.MERGE_CONTENT_TYPE
      }
    }).then(_common.dataExtractor);
  }

};

const Delete = Service => class Delete extends Service {
  async delete(id, options) {
    await this.client.delete(id, (0, _common.createRequestConfig)(options));
  }

};

const List = Service => class List extends Service {
  list(query = {}, options = {}) {
    const url = `/${(0, _common.getQueryParams)(query)}`;
    return this.client.get(url, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

};

class CrudBuilder {
  constructor(baseService) {
    this.BaseService = baseService;
  }

  create() {
    // eslint-disable-next-line new-cap
    this.BaseService = Create(this.BaseService);
    return this;
  }

  retrieve() {
    // eslint-disable-next-line new-cap
    this.BaseService = Retrieve(this.BaseService);
    return this;
  }

  update() {
    // eslint-disable-next-line new-cap
    this.BaseService = Update(this.BaseService);
    return this;
  }

  patch() {
    // eslint-disable-next-line new-cap
    this.BaseService = Patch(this.BaseService);
    return this;
  }

  delete() {
    // eslint-disable-next-line new-cap
    this.BaseService = Delete(this.BaseService);
    return this;
  }

  list() {
    // eslint-disable-next-line new-cap
    this.BaseService = List(this.BaseService);
    return this;
  }

  build() {
    return this.BaseService;
  }

}
/* eslint-enable max-classes-per-file, @typescript-eslint/no-shadow */


exports.CrudBuilder = CrudBuilder;